import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import {
  TextField,
  Button,
  Box,
  Card,
  Typography,
  Switch,
  FormControlLabel,
  CircularProgress,
  Snackbar,
  Alert,
} from "@mui/material";
import { API_ENDPOINTS } from "../../../config/api";

const API_URL = API_ENDPOINTS.USER_TYPES;

const EditUserTypeForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [userType, setUserType] = useState({
    name: "",
    publish: false,
  });
  const [loading, setLoading] = useState(true);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  useEffect(() => {
    fetchUserType();
  }, []);

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") return;
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  const fetchUserType = async () => {
    try {
      const response = await axios.get(API_URL.EDIT(id));
      setUserType({
        name: response.data.userType.name || "",
        publish: response.data.userType.publish || false,
      });
      setLoading(false);
    } catch (error) {
      console.error("Error fetching user type:", error);
      setSnackbar({
        open: true,
        message: "Failed to load user type data",
        severity: "error",
      });
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    setUserType({ ...userType, [e.target.name]: e.target.value });
  };

  const handlePublishToggle = () => {
    setUserType((prev) => ({ ...prev, publish: !prev.publish }));
  };

  const handleUpdate = async () => {
    try {
      await axios.put(API_URL.EDIT(id), userType);
      setSnackbar({
        open: true,
        message: "User Type updated successfully!",
        severity: "success",
      });
      // Add a small delay before navigation to show the success message
      setTimeout(() => {
        navigate(-1);
      }, 1000);
    } catch (error) {
      console.error("Error updating user type:", error);
      setSnackbar({
        open: true,
        message: "Failed to update user type: " + (error.response?.data?.message || "Something went wrong"),
        severity: "error",
      });
    }
  };

  if (loading) {
    return <CircularProgress sx={{ display: "block", margin: "auto", mt: 5 }} />;
  }

  return (
    <Card sx={{ p: 4, maxWidth: 500, mx: "auto", mt: 5 }}>
      <Typography variant="h5" mb={3}>
        Edit User Type
      </Typography>
      <Box display="flex" flexDirection="column" gap={3}>
        <TextField
          label="User Type Name"
          name="name"
          value={userType.name}
          onChange={handleChange}
          required
        />
        <FormControlLabel
          control={
            <Switch
              checked={userType.publish}
              onChange={handlePublishToggle}
              color="primary"
            />
          }
          label="Published"
        />
        <Box display="flex" justifyContent="space-between" gap={2}>
          <Button variant="contained" color="primary" onClick={handleUpdate}>
            Update
          </Button>
          <Button variant="outlined" color="secondary" onClick={() => navigate(-1)}>
            Cancel
          </Button>
        </Box>
      </Box>

      {/* Snackbar for notifications */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert onClose={handleSnackbarClose} severity={snackbar.severity} sx={{ width: "100%" }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Card>
  );
};

export default EditUserTypeForm;
